import { lookupNestedProp, setNestedProp } from "./Table";
export class DependencyFinder {
    constructor(before, after) { this.before = void 0; this.after = void 0; this.toClear = []; this.before = before; this.after = after; }
    forColumn(col) {
        var _this = this;
        return { props: function () {
                const out = {};
                for (var _len = arguments.length, k = new Array(_len), _key = 0; _key < _len; _key++) {
                    k[_key] = arguments[_key];
                }
                k.map(k => {
                    setNestedProp(out, k, lookupNestedProp(_this.before, k));
                    if (!col.editKey)
                        return; // @ts-ignore
                    if (lookupNestedProp(_this.before, k) !== lookupNestedProp(_this.after, k)) {
                        _this.toClear.push(col.editKey);
                    }
                });
                return out;
            } };
    }
    keysToClear() { return this.toClear; }
}
